import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function DispatchSettingsDialog({ open, onOpenChange, rules, setRules, onSave }) {
  if (!rules) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-border text-foreground max-w-md">
        <DialogHeader>
          <DialogTitle>Auto-Dispatch Rules</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={rules.auto_dispatch_enabled || false}
              onChange={e => setRules({ ...rules, auto_dispatch_enabled: e.target.checked })}
              className="rounded"
            />
            <span className="text-sm">Enable auto-dispatch for new loads</span>
          </label>

          <div>
            <label className="text-xs text-muted-foreground">Min score threshold: {rules.min_score_threshold || 70}%</label>
            <input
              type="range" min="30" max="95"
              value={rules.min_score_threshold || 70}
              onChange={e => setRules({ ...rules, min_score_threshold: parseInt(e.target.value) })}
              className="w-full mt-1"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-muted-foreground">Max offers per load</label>
              <Input
                type="number"
                value={rules.max_offers_per_load || 3}
                onChange={e => setRules({ ...rules, max_offers_per_load: parseInt(e.target.value) })}
                className="bg-muted border-input text-foreground mt-1"
              />
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Max deadhead (km)</label>
              <Input
                type="number"
                value={rules.max_deadhead_km || 200}
                onChange={e => setRules({ ...rules, max_deadhead_km: parseInt(e.target.value) })}
                className="bg-muted border-input text-foreground mt-1"
              />
            </div>
          </div>

          <div>
            <p className="text-xs text-muted-foreground mb-2">Scoring Weights (must total 100)</p>
            <div className="space-y-2">
              {[
                { key: 'proximity_weight', label: 'Proximity' },
                { key: 'equipment_weight', label: 'Equipment' },
                { key: 'availability_weight', label: 'Availability' },
                { key: 'history_weight', label: 'History' },
                { key: 'cost_weight', label: 'Cost' },
              ].map(w => (
                <div key={w.key} className="flex items-center gap-3">
                  <span className="text-xs text-muted-foreground w-20">{w.label}</span>
                  <input
                    type="range" min="0" max="50"
                    value={rules[w.key] || 20}
                    onChange={e => setRules({ ...rules, [w.key]: parseInt(e.target.value) })}
                    className="flex-1"
                  />
                  <span className="text-xs text-muted-foreground w-8 text-right">{rules[w.key] || 20}</span>
                </div>
              ))}
            </div>
          </div>

          <Button className="w-full bg-brand-accent text-brand-accent-foreground" onClick={onSave}>
            Save Rules
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
